import { memo, useEffect, useMemo, useState } from "react";
import { string, arrayOf, oneOfType, object, shape, number } from "prop-types";
import { unzip } from "@repo/utils";
import { CommentRootModel, StructureModel } from "@repo/structure";
import { PROJECT_TYPE } from "@utils";
import {
  EstimateEditorStoreProvider,
  EstimateStructureProvider,
  EstimateEditorStore,
  EditorContainer,
  TableBreakdown,
  EstimateEditorSettingsProvider,
  Versioning,
  EstimateCommentsProvider,
} from "@tools";
import { useStores } from "@hooks";
import { PageCircularProgress } from "@components";
import { Grid } from "@material-ui/core";

export const TemplatePreview = memo(({
  versionData,
  versionStructure,
  workTypes,
  commentList,
  // useNewWorkTypes,
}) => {
  const { userStore } = useStores();
  
  const [isLoading, setLoading] = useState(true);
  const [structure, setStructure] = useState(null);
  const commentStore = useMemo(() => CommentRootModel.create({ groups: [] }), []);
  
  const store = useMemo(() => new EstimateEditorStore({
    estimateType: PROJECT_TYPE.STANDARD,
    workTypes,
    defaultEstimateVersionsForPreview: versionData,
    defaultComments: commentList,
  }), []);

  useEffect(() => {
    (async () => {
      let structureData;
      if(typeof versionStructure === "string" && versionStructure[0] !== "{") {// may be blank
        try {
          structureData = JSON.parse(unzip(versionStructure));
        } catch(e) {
          try {
            structureData = JSON.parse(unzip(unzip(versionStructure)));
          } catch(e) {
            console.log("TEMPLATE PARSE FAIL", JSON.stringify(e));
          }
        }
      } else if(versionStructure)
        structureData = versionStructure;
      
      // const parsedStructure = await structureCreator({
      //   zippedTemplateStructure: versionStructure,
      //   workTypes,
      //   // createNewTags: useNewWorkTypes
      // });
      setStructure(StructureModel.create(structureData));
      setLoading(false);
    })();
  }, []);

  if (isLoading || !structure) return <PageCircularProgress />;
  
  return (
    <EstimateCommentsProvider value={commentStore}>
      <EstimateEditorStoreProvider value={store}>
        <EstimateStructureProvider value={structure}>
          <EstimateEditorSettingsProvider
            hasSellerPrivileges={userStore.isBusinessUser}
            showChatThread
            previewMode
          >
            <EditorContainer>
              <Grid
                item
                container
                direction="column"
                alignItems="center"
              >
                {
                  versionData?.length > 1 &&
                  <Grid
                    item container
                    justifyContent="flex-end"
                    className="-mx-12 -mt-6 mb-3 px-12 py-3 bg-secondary"
                    style={{ width: "calc(100% + 96px)" }}
                  >
                    <Versioning />
                  </Grid>
                }
                <TableBreakdown forceCollapseReveal />
              </Grid>
            </EditorContainer>
          </EstimateEditorSettingsProvider>
        </EstimateStructureProvider>
      </EstimateEditorStoreProvider>
    </EstimateCommentsProvider>
  );
});

TemplatePreview.propTypes = {
  versionStructure: oneOfType([string, object]).isRequired,
  workTypes: arrayOf(object),
  // useNewWorkTypes: bool,
  commentList: arrayOf(object),
  versionData: arrayOf(shape({
    key: number,
    order: number,
    name: string,
  })),
};
